import { render } from "./ReinstallVm.vue?vue&type=template&id=f968076c&scoped=true"
import script from "./ReinstallVm.vue?vue&type=script&lang=js"
export * from "./ReinstallVm.vue?vue&type=script&lang=js"

import "./ReinstallVm.vue?vue&type=style&index=0&id=f968076c&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f968076c"]])

export default __exports__